<template>
    <div>
        <div class="row mb-8">
            <div class="col-6 d-flex justify-content-start">
                <v-card-title>{{ $t('suppliers.edit.supplier') }}</v-card-title>
            </div>
            <div class="col-6 d-flex justify-content-end">
                <genericBtnComponent v-if="isSupplier() && tab == 'option-1'" :ClickFun="UpdateStatusToCompleted"
                    svg="1" :Title="$t('suppliers.edit.ToBeCompleted')" :loader="ToBeValidatedLoader"
                    :style="{ marginRight: '10px' }" :disabled="yesDisable || Status==3" />
                <genericBtnComponent v-if="tab == 'option-1'" :ClickFun="SaveAndContinue" svg="1"
                    :Title="$t('suppliers.edit.save')" :loader="BtnLoader" :disabled="yesDisable" />
                <genericBtnComponent v-if="tab == 'option-2'" :ClickFun="SaveAndContinue" svg="1"
                    :Title="$t('suppliers.edit.save')" :loader="BtnLoader" :disabled="yesDisable" />
                <genericBtnComponent v-if="tab == 'option-3'" @click="AddUsers = true"
                    :disabled="!validationWriteButton" v-bind:idSupplier="idSupplier" svg="2"
                    :Title="$t('suppliers.edit.user')" />
                <genericBtnComponent v-if="tab == 'option-4'" @click="AddDocument = true"
                    :disabled="!validationWriteButton" v-bind:idSupplier="idSupplier" svg="2"
                    :Title="$t('suppliers.edit.document')" />
                <genericBtnComponent v-if="tab == 'option-5'" @click="AddBankAccount = true"
                    :disabled="!validationWriteButton" v-bind:idSupplier="idSupplier" svg="2"
                    :Title="$t('suppliers.edit.bankAccount')" />
                <genericBtnComponent v-if="tab == 'option-7'" @click="AddLocation = true"
                    :disabled="!validationWriteButton" v-bind:idSupplier="idSupplier" svg="2"
                    :Title="$t('suppliers.edit.Location')" />
            </div>
        </div>
    </div>
    <v-card flat>
        <v-tabs v-model="tab" background-color="transparent" color="basil" grow fixed-tabs>
            <v-tab class="slider" value="option-1" :style="NotActive" centered v-model="general">
                {{ $t('suppliers.general') }}</v-tab>
            <v-tab class="slider" value="option-2" :style="NotActive"> {{ $t('suppliers.invoicing') }}</v-tab>
            <v-tab class="slider" value="option-3" :style="NotActive"> {{ $t('suppliers.users') }}</v-tab>
            <v-tab class="slider" value="option-7" :style="NotActive"> {{ $t('suppliers.location') }}</v-tab>
            <v-tab class="slider" value="option-4" :style="NotActive"> {{ $t('suppliers.documents') }}</v-tab>
            <v-tab class="slider" value="option-5" :style="NotActive"> {{ $t('suppliers.bankAccounts') }}</v-tab>
            <v-tab class="slider" value="option-6" :style="NotActive"> {{ $t('suppliers.validation') }}</v-tab>
        </v-tabs>
        <v-divider class="ma-0"></v-divider>
        <v-window v-model="tab" :key="tab">
            <v-window-item value="option-1">
                <supplier-general-information-tab
                    @getDataFromGeneralInformation="getDataFromEditSupplierGeneralInformation"
                    ref="generalInformationListRef" @disable="disableSendForValidationBtn" />
            </v-window-item>
            <v-window-item value="option-2">
                <InvoicingTab @getDataFromInvoicing="getDataFromEditSupplierInvoicing" ref="invoicingListRef" />
            </v-window-item>
            <v-window-item value="option-3">
                <supplier-users-tab ref="UserListRef" v-bind:idSupplier="idSupplier"
                    :validationButton="validationButton" />
            </v-window-item>
            <v-window-item value="option-7">
                <supplier-location-tab ref="LocationRef" v-bind:idSupplier="idSupplier"/>
            </v-window-item>
            <v-window-item value="option-4">
                <supplier-documents-tab ref="DocumentsListRef" v-bind:idSupplier="idSupplier"
                    :validationButton="validationButton" />
            </v-window-item>
            <v-window-item value="option-5">
                <supplier-Bank-Account-tab ref="BankAccountListRef" v-bind:idSupplier="idSupplier"
                    :validationButton="validationButton" />
            </v-window-item>
            <v-window-item value="option-6">
                <supplier-Validation-tab ref="ValidationRef" v-bind:idSupplier="idSupplier"
                    :validationButton="validationButton" @getStatusSupplier="setStatusSupplier" />
            </v-window-item>
        </v-window>
    </v-card>
    <AddDocument v-model="AddDocument" @add-document-close-dialog="AddDocument = false"
        :reloadListDocuments="reloadListDocuments" />
    <AddUsers v-model="AddUsers" @add-user-close-dialog="AddUsers = false" :reloadListUser="reloadListUser" />
    <AddBankAccount v-model="AddBankAccount" @add-bank-account-close-dialog="AddBankAccount = false"
        :reloadListBankAccount="reloadListBankAccount" />
    <AddSupplierLocation v-model="AddLocation" @add-location-close-dialog="AddLocation = false" :reloadListLocation="reloadListLocation" />

</template>
<script>
import SupplierDocumentsTab from "./SupplierDocumentsTab.vue";
import InvoicingTab from "./InvoicingTab.vue"
import supplierBankAccountTab from "./SupplierBankAccountTab.vue";
import supplierValidationTab from "./SupplierValidationTab.vue";
import SupplierGeneralInformationTab from './SupplierGeneralInformationTab.vue';
import SupplierLocationTab from './SupplierLocationTab.vue';
import SupplierUsersTab from './SupplierUsersTab.vue';
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue";
import AddUsers from "../SuppliersEdit/AddUsers.vue";
import AddBankAccount from "../SuppliersEdit/AddBankAccount.vue";
import AddSupplierLocation from "../SuppliersEdit/AddSupplierLocation.vue";
import { editSupplierGeneralInformation, isSupplier, idSupplier, getSupplierById, GetStatusSuppliers, CheckPermissionByUser, editSupplierInvoicing, SendForValidation } from '@/api/index';
import AddDocument from './AddDocument.vue';
import { status } from "@/enums/Status";
export default {
    mounted() {
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.suppliers');
        this.idSupplier = isSupplier() ? idSupplier() : this.$route.params.id;
        this.getStatusSupplierById();
        this.checkSupplierPermission();
        this.checkSupplierWritePermission();
    },
    name: "SupplierEdit",
    components: {
        SupplierDocumentsTab,
        SupplierGeneralInformationTab,
        SupplierUsersTab,
        supplierBankAccountTab,
        supplierValidationTab,
        SupplierLocationTab,
        genericBtnComponent,
        AddDocument,
        AddUsers,
        AddBankAccount,
        AddSupplierLocation,
        InvoicingTab
    },
    data: () => ({
        yesDisable: false,
        ToBeValidatedLoader: false,
        BtnLoader: false,
        UserListKey: 0,
        idSupplier: null,
        tab: "option-1",
        general: true,
        step: 1,
        AddUser: false,
        AddDocument: false,
        UsersTab: false,
        DocumentsTab: false,
        AddUsers: false,
        AddLocation: false,
        AddBankAccount: false,
        validationButton: false,
        validationWriteButton: false,
        NotActive: {
            color: "#667280",
            fontSize: "14px",
            font: "inter",
        },
        Active: {
            color: "#00CBA0",
            fontSize: "14px",
            font: "inter",
        },
        dataFromEditSupplierGeneralInformation: null,
        dataFromEditSupplierInvoicing: null,
        canEditGeneralInformation: null,
        isDisabled: {
            type: Boolean,
            default: false
        },
        Status: null,
        StatusLoader: null
    }),
    created() {
        this.GetStatusSuppliers();
    },
    methods: {
        disableSendForValidationBtn() {
            this.yesDisable = true;
        },
        isSupplier() {
            return isSupplier()
        },
        GetStatusSuppliers() {
            GetStatusSuppliers().then(response => {
                localStorage.setItem(status.ToBeCompleted + this.$i18n.availableLocales[0], response.data.ToBeCompleted.en);
                localStorage.setItem(status.ToBeCompleted + this.$i18n.availableLocales[1], response.data.ToBeCompleted.fr);
                localStorage.setItem(status.ToBeValidated + this.$i18n.availableLocales[0], response.data.ToBeValidated.en);
                localStorage.setItem(status.ToBeValidated + this.$i18n.availableLocales[1], response.data.ToBeValidated.fr);
                localStorage.setItem(status.Validated + this.$i18n.availableLocales[0], response.data.Validated.en);
                localStorage.setItem(status.Validated + this.$i18n.availableLocales[1], response.data.Validated.fr);
                localStorage.setItem(status.Refused + this.$i18n.availableLocales[0], response.data.Refused.en);
                localStorage.setItem(status.Refused + this.$i18n.availableLocales[1], response.data.Refused.fr);
            })
        },
        ActiveDeletedSnackBar() {
            this.getParent('MainLayout').ActiveDeletedSnackBar();
        },
        ActiveWarningSnackBar() {
            this.getParent('MainLayout').ActiveWarningSnackBar();
        },
        ActiveSavedSnackBar() {
            this.getParent('MainLayout').ActiveSavedSnackBar();
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
        checkSupplierWritePermission: function () {
            CheckPermissionByUser("Optima.Suppliers.Write")
                .then((response) => {
                    this.validationWriteButton = response.data;
                })
                .catch(() => {
                    this.validationWriteButton = false;
                });
        },
        checkSupplierPermission: function () {
            CheckPermissionByUser("Optima.Suppliers.readWrite")
                .then((response) => {
                    this.validationButton = response.data;
                })
                .catch(() => {
                    this.validationButton = false;
                });
        },
        UpdateStatusToCompleted() {
            this.ToBeValidatedLoader = true;
            SendForValidation().then(() => {
                this.ActiveSavedSnackBar();
            }).catch(() => {
                this.ActiveWarningSnackBar();
            }).finally(() => {
                this.ToBeValidatedLoader = false;
            })
        },
        SaveAndContinue() {
            if (this.tab == "option-1") {
                this.BtnLoader = true;
                this.putGeneralInformation();
            } else if (this.tab == "option-2") {
                this.BtnLoader = true;
                this.putInvoicing();
            }
        },
        getDataFromEditSupplierGeneralInformation(value) {
            this.dataFromEditSupplierGeneralInformation = value;
        },
        getDataFromEditSupplierInvoicing(value) {
            this.dataFromEditSupplierInvoicing = value;
        },
        putGeneralInformation: function () {
            if (this.$refs.generalInformationListRef.ControleSaisir()) {
                editSupplierGeneralInformation(this.dataFromEditSupplierGeneralInformation)
                    .then(() => {
                        this.ActiveSavedSnackBar()
                    })
                    .catch(() => {
                        this.ActiveWarningSnackBar()
                    }).finally(() => {
                        this.BtnLoader = false;
                    });
            } else {
                this.BtnLoader = false;
            }
        },
        putInvoicing: function () {
            if (this.$refs.invoicingListRef.ControleSaisir()) {
                editSupplierInvoicing(this.dataFromEditSupplierInvoicing).then(() => {
                    this.ActiveSavedSnackBar()
                })
                    .catch(() => {
                        this.ActiveWarningSnackBar()
                    }).finally(() => {
                        this.BtnLoader = false;
                    });
            } else {
                this.BtnLoader = false;
            }
        },
        reloadListDocuments() {
            this.$refs.DocumentsListRef.GetDocumentslist()
        },
        reloadListUser() {
            this.$refs.UserListRef.getUserlist()
        },
        reloadListLocation() {
            this.$refs.LocationRef.getSupplierLocationlist()
        },
        reloadListBankAccount() {
            this.$refs.BankAccountListRef.getBankAccountList()
        },
        getStatusSupplierById: function () {
            this.StatusLoader = true
            getSupplierById(this.idSupplier)
                .then(({ data }) => {
                    this.Status = data.validationStatus
                }).finally(() => {
                    this.StatusLoader = false;
                });
        },
        setStatusSupplier: function () {
            getSupplierById(this.idSupplier)
                .then(({ data }) => {
                    this.Status = data.validationStatus
                })
        },
    },
    computed: {
        statusText() {
            switch (this.Status) {
                case 1: return localStorage.getItem(status.created + this.$i18n.locale);
                case 2: return localStorage.getItem(status.validatedClient1 + this.$i18n.locale);
                case 3: return localStorage.getItem(status.validatedBySupplier + this.$i18n.locale);
                case 4: return localStorage.getItem(status.validatedByClient2 + this.$i18n.locale);
                default: return localStorage.getItem(status.created + this.$i18n.locale);
            }
        }
    }
}
</script>
<style scoped>
.v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.text-basil {
    color: #114ef7 !important;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    font-family: inter;
}

.slider {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    flex: content;
    border-bottom: "2px solid black";
}

.disabled {
    opacity: 0.5;
    pointer-events: none;
}
</style>